//import React from 'react';
import { Address } from '../model/fbb/session/Address';
import { Plan } from '../model/fbb/session/Plan';
import { AllCoverage } from '../model/fbb/session/AllCoverage';
import { UserProfileSimple } from '../model/fbb/session/UserProfileSimple';
import { FbbError } from '../model/fbb/session/FbbError';
import * as log from '../common/js/appLogger';
import { AllAddOn } from '../model/fbb/session/AllAddOn';
//import {CustomerType} from "../model/fbb/FbbEnum"

export class UserData {
	static address: Address | null = null;
	static allCoverage: AllCoverage | null = null;
	static plan: Plan;
	static userProfile: UserProfileSimple | null = null;
	static fbbError: FbbError | null = null;
	static allAddon: AllAddOn | null = null;
	static tempPlanResult: any | null = null;
	static channel: string | null = null; //follow entry point? not save to session
	//static availablePlansJson:any | null = null //not save to session. API return result

	//add a class for storing page logic that need to save to session.
	//e.g. sorry page's reason

	static clearUserInput() {
		log.i('clearUserInput');
		UserData.address?.cleanStorage();
		UserData.allCoverage?.cleanStorage();
		UserData.plan?.cleanStorage();
		UserData.userProfile?.cleanStorage();
		UserData.fbbError?.cleanStorage();
		UserData.allAddon?.cleanStorage();

		//UserData.availablePlansJson = null
	}
	static init() {
		log.it('UserData', 'init');
		UserData.address = new Address();
		UserData.allCoverage = new AllCoverage();
		UserData.plan = new Plan();
		UserData.channel = null;
		UserData.userProfile = new UserProfileSimple();
		UserData.fbbError = new FbbError();
		UserData.allAddon = new AllAddOn();

		//UserData.availablePlansJson = null
	}

	static load() {
		UserData.init();
		UserData.address?.load();
		UserData.allCoverage?.load();
		UserData.userProfile?.load();
		UserData.plan?.load();
		UserData.fbbError?.load();
		UserData.allAddon?.load();
		log.ot('UserData.load fbbError', UserData.fbbError);
	}
}
